import { createReducer, on } from "@ngrx/store";
import {
  fetchTopCampaigns,
  fetchTopCampaignsSuccess,
  fetchTopCampaignsFailure,
  fetchTopPromotion,
  fetchTopPromotionSuccess,
  fetchTopPromotionFailure,
  fetchTopreferringUrls,
  fetchTopreferringUrlsSuccess,
  fetchTopreferringUrlsFailure,
  fetchBalanceSheet,
  fetchBalanceSheetSuccess,
  fetchBalanceSheetFailure,
  fetchChannels,
  fetchChannelsSuccess,
  fetchChannelsFailure,
  fetchGeneratedCommission,
  fetchGeneratedCommissionSuccess,
  fetchGeneratedCommissionFailure,
  getGeneratedCommission,
  getGeneratedCommissionSuccess,
  getGeneratedCommissionFailure,
  fetchCampaigns,
  fetchCampaignsSuccess,
  fetchCampaignsFailure,
  fetchUsers,
  fetchUsersSuccess,
  fetchUsersFailure,
  clearReports
} from "./report.actions";

import { IState } from "@models/index";

const initialState: IState = {
  isLoaded: false,
  data: [],
  selectedItem: {},
  error: null,
  total: 0,
  maxPages: 0,
  perPage: 0,
  currentPage: 0,
};

const _reportReducer = createReducer(
  initialState,
  on(fetchUsers, (state, { page, filterOptions }) => {
    return state;
  }),
  on(fetchUsersSuccess, (state, { users }) => {
    return { ...state, data: users };
  }),
  on(fetchUsersFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error,
    };
    return { ...state, ...payload };
  }),
  on(fetchCampaigns, (state, { page, filterOptions }) => {
    return state;
  }),
  on(fetchCampaignsSuccess, (state, { campaign }) => {
    const payload = {
      isLoaded: true,
      data: campaign.data,
      total: campaign.total,
      maxPages: campaign.maxPages,
      perPage: campaign.perPage,
      currentPage: campaign.currentPage,
      selectedItem: {},
    };

    return { ...state, ...payload };
  }),
  on(fetchCampaignsFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error,
    };
    return { ...state, ...payload };
  }),
  on(fetchTopCampaigns, (state, { page, filterOptions }) => {
    return state;
  }),
  on(fetchTopCampaignsSuccess, (state, { topCampaign }) => {
    const payload = {
      isLoaded: true,
      data: topCampaign.data,
      total: topCampaign.total,
      maxPages: topCampaign.maxPages,
      perPage: topCampaign.perPage,
      currentPage: topCampaign.currentPage,
      selectedItem: {},
    };

    return { ...state, ...payload };
  }),
  on(fetchTopCampaignsFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error,
    };
    return { ...state, ...payload };
  }),
  
  on(clearReports, (state) => {
    const data={
      ...state, 
      data:[]
    };
    console.log(data)
    return { ...state, data:[] };
  }),

  on(fetchTopPromotion, (state, { page, filterOptions }) => {
    return state;
  }),
  on(fetchTopPromotionSuccess, (state, { topPromotion }) => {
    const payload = {
      isLoaded: true,
      data: topPromotion.data,
      total: topPromotion.total,
      maxPages: topPromotion.maxPages,
      perPage: topPromotion.perPage,
      currentPage: topPromotion.currentPage,
      selectedItem: {},
    };

    return { ...state, ...payload };
  }),
  on(fetchTopPromotionFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error,
    };
    return { ...state, ...payload };
  }),
  on(fetchTopreferringUrls, (state, { page, filterOptions }) => {
    return state;
  }),
  on(fetchTopreferringUrlsSuccess, (state, { topRefUrls }) => {
    const payload = {
      isLoaded: true,
      data: topRefUrls.data,
      total: topRefUrls.total,
      maxPages: topRefUrls.maxPages,
      perPage: topRefUrls.perPage,
      currentPage: topRefUrls.currentPage,
      selectedItem: {},
    };

    return { ...state, ...payload };
  }),
  on(fetchTopreferringUrlsFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error,
    };
    return { ...state, ...payload };
  }),
  on(fetchBalanceSheet, (state, { page, filterOptions }) => {
    return state;
  }),
  on(fetchBalanceSheetSuccess, (state, { balanceSheet }) => {
    const payload = {
      isLoaded: true,
      data: balanceSheet.data,
      total: balanceSheet.total,
      maxPages: balanceSheet.maxPages,
      perPage: balanceSheet.perPage,
      currentPage: balanceSheet.currentPage,
      selectedItem: {},
    };

    return { ...state, ...payload };
  }),
  on(fetchBalanceSheetFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error,
    };
    return { ...state, ...payload };
  }),
  on(fetchChannels, (state, { page, filterOptions }) => {
    return state;
  }),
  on(fetchChannelsSuccess, (state, { channel }) => {
    const payload = {
      isLoaded: true,
      data: channel.data,
      total: channel.total,
      maxPages: channel.maxPages,
      perPage: channel.perPage,
      currentPage: channel.currentPage,
      selectedItem: {},
    };
    return { ...state, ...payload };
  }),
  on(fetchChannelsFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error,
    };
    return { ...state, ...payload };
  }),
  on(fetchChannels, (state, { page, filterOptions }) => {
    return state;
  }),
  on(fetchChannelsSuccess, (state, { channel }) => {
    const payload = {
      isLoaded: true,
      data: channel.data,
      total: channel.total,
      maxPages: channel.maxPages,
      perPage: channel.perPage,
      currentPage: channel.currentPage,
      selectedItem: {},
    };
    return { ...state, ...payload };
  }),
  on(fetchChannelsFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error,
    };
    return { ...state, ...payload };
  }),
  on(fetchGeneratedCommission, (state, { page, filterOptions }) => {
    return state;
  }),
  on(fetchGeneratedCommissionSuccess, (state, { generatedComm }) => {
    const payload = {
      isLoaded: true,
      data: generatedComm.data,
      total: generatedComm.total,
      maxPages: generatedComm.maxPages,
      perPage: generatedComm.perPage,
      currentPage: generatedComm.currentPage,
      selectedItem: {},
    };
    return { ...state, ...payload };
  }),
  on(fetchGeneratedCommissionFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error,
    };
    return { ...state, ...payload };
  }),
  on(getGeneratedCommission, (state, { genCommID }) => {
    return state;
  }),
  on(getGeneratedCommissionSuccess, (state, { genComm }) => {
    const payload = {
      selectedItem: genComm,
    };
    return { ...state, ...payload };
  }),
  on(getGeneratedCommissionFailure, (state, { error }) => {
    const payload = {
      error,
    };
    return { ...state, ...payload };
  })
);

export function reportReducer(state, action) {
  return _reportReducer(state, action);
}
